import { render } from "./CreateProjectDialog.vue?vue&type=template&id=033b3d54"
import script from "./CreateProjectDialog.vue?vue&type=script&lang=js"
export * from "./CreateProjectDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__